<template>
  <div class="flex flex-row-reverse justify-end md:justify-center items-center cursor-pointer md:gap-[8px] relative bg-transparent">
    <p
      class="text-sm text-grays-800 font-medium"
      :class="disabled ? 'text-grays-600' : ''"
    >
      <slot></slot>
    </p>
    <div class="w-[28px] h-[28px] flex justify-center items-center text-primary-700">
      <input
        :checked="isChecked"
        :disabled="disabled || shouldPreventUncheck"
        @change="updateCheckbox"
        type="checkbox"
        :class="[
          ' opacity-0 absolute w-full h-full top-0 left-0',
          disabled ? 'cursor-default' : 'cursor-pointer'
        ]"
        style="z-index: 1;"
      />
      <span
        v-if="!isChecked"
        class="material-symbols-rounded w-[21px] h-[21px] text-[21px]"
        :class="disabled ? 'text-grays-600' : ''"
      >
        check_box_outline_blank
      </span>
      <span
        v-else
        class="material-symbols-rounded w-[21px] h-[21px] text-[21px]"
        :class="disabled ? 'text-grays-600' : ''"
      >
        check_box
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "check-box",
  props: {
    modelValue: {
      type: [Boolean, Number], // Accepts both Boolean and Number types
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    preventUncheck: {
      type: Boolean,
      default: false,
    },

  },
  computed: {
    isChecked() {
      return this.modelValue === true || this.modelValue === 1;
    },
    shouldPreventUncheck() {
      return this.preventUncheck && this.isChecked;
    },
  },
  methods: {
    updateCheckbox(e) {
      // Check the type of modelValue and emit the appropriate value
      if (typeof this.modelValue === 'boolean') {
        this.$emit("update:modelValue", e.target.checked);
      } else if (typeof this.modelValue === 'number') {
        this.$emit("update:modelValue", e.target.checked ? 1 : 0);
      }
    },
	},
};
</script>

<style></style>
